import { RoutingTabTitleService } from '@shared/service/routing-tab-title/routing-tab-title.service';
import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CategoryService } from '../../services/category.service';
import { BreadcrumbItem, SeoComponent } from '@shared/components';
import { filter, map, tap } from 'rxjs/operators';
import { BreadcrumbComponent } from '../../../shared/components/breadcrumb/breadcrumb.component';
import { ProductsCategoriesComponent } from '../../components/products-categories/products-categories.component';
import { ProductsListingComponent } from '../../components/products-listing/products-listing.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-category',
    templateUrl: './category.component.html',
    styleUrls: ['./category.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [CategoryService],
    imports: [BreadcrumbComponent, ProductsCategoriesComponent, ProductsListingComponent, AsyncPipe],
})
export class CategoryComponent extends SeoComponent implements OnInit {
    private activatedRoute = inject(ActivatedRoute);
    private categoryService = inject(CategoryService);
    private routingTabTitleService = inject(RoutingTabTitleService);

    categorySlug?: string;
    category$ = this.categoryService.category$;

    breadcrumbs$ = this.category$.pipe(
        filter((category) => category !== null),
        map((category) => {
            return [
                ...this.breadcrumbs,
                {
                    name: category.name,
                    url: null,
                },
            ];
        }),
    );

    breadcrumbs: BreadcrumbItem[] = [
        {
            name: 'NAVIGATION.MAIN.main_page',
            url: '/',
        },
        {
            name: 'NAVIGATION.MAIN.products',
            url: '/products',
        },
    ];

    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions$.add(
            this.category$
                .pipe(
                    filter((value) => value != null),
                    tap((value) => {
                        this.routingTabTitleService.setTitle(`${value.name} | PZ Stelmach`);
                    }),
                )
                .subscribe(),
        );
        this.subscriptions$.add(
            this.activatedRoute.params
                .pipe(
                    tap((params) => {
                        this.categorySlug = params['slug'];
                        if (this.categorySlug) {
                            this.categoryService.dispatch(this.categorySlug);
                        }
                    }),
                )
                .subscribe(),
        );
        this.subscriptions$.add(
            this.routingTabTitleService.currentPageTitle$
                .pipe(
                    tap(() => {
                        const titleWithSlug = `${this.categorySlug} | PZ Stelmach`;
                        this.seoTitle$.next(titleWithSlug);
                        this.seoDescription$.next(this.routingTabTitleService.translateTitle('SEO.PRODUCTS.CATEGORY.description'));
                    }),
                )
                .subscribe(),
        );
    }
}
